import Route from "@ember/routing/route";
import { service } from "@ember/service";
import type RouterService from "@ember/routing/router-service";
import { DEFAULT_PRESET } from "#models/data/presets.ts";

export default class IndexRoute extends Route {
  @service declare router: RouterService;

  /**
   * Redirects to `/play/:default_song_data`.
   */
  beforeModel(): void {
    console.log("[route:index] redirecting to default song");
    this.router.transitionTo("play.song", DEFAULT_PRESET.data);
  }
}
